$(function(){
// IPad/IPhone
	var viewportmeta = document.querySelector && document.querySelector('meta[name="viewport"]'),
	ua = navigator.userAgent,

	gestureStart = function () {viewportmeta.content = "width=device-width, minimum-scale=0.25, maximum-scale=1.6";},

	scaleFix = function () {
		if (viewportmeta && /iPhone|iPad/.test(ua) && !/Opera Mini/.test(ua)) {
			viewportmeta.content = "width=device-width, minimum-scale=1.0, maximum-scale=1.0";
			document.addEventListener("gesturestart", gestureStart, false);
		}
	};
	
	scaleFix();
	// Menu Android
	var userag = navigator.userAgent.toLowerCase();
	var isAndroid = userag.indexOf("android") > -1; 
	if(isAndroid) {
		$('.menu').responsiveMenu({autoArrows:true});
	}
    
    //load fb and twitter images
	var fbIconImage = $('<img src="/content/images/facebook-icon-small.png">');
	fbIconImage.appendTo('#facebookIconHeader');

	var twitterIconImage = $('<img src="/content/images/twitter-icon-small.png">');
	twitterIconImage.appendTo('#twitterIconHeader');

	var instagramIconImage = $('<img src="/content/images/instagram-icon-small.png">');
	instagramIconImage.appendTo('#instagramIconHeader');
});